import { Component, Input, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import * as luxon from 'luxon';

@Component({
  selector: 'fgb-ecash-button',
  templateUrl: './ecash-button.component.html',
  styleUrls: ['./ecash-button.component.scss'],
})
export class EcashButtonComponent implements OnInit {
  @Input() isMemberCard: boolean = true;

  cardToken$: Observable<CardToken | undefined>;
  cardIssuerProvider = 'Central Bank';

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }

  isExpiried(expiryDate: string | Date | null) {
    if (!expiryDate) return false;
    const now = luxon.DateTime.utc();
    const expiriedDate = luxon.DateTime.fromISO(expiryDate.toString());
    return now > expiriedDate;
  }
}
